module.exports = __webpack_public_path__ + "static/Anika-6b0ca19c75a97542f3283220fc001a25.jpg";